<template>
  <el-header class="navbar">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }"><i class="el-icon-s-home"></i></el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="item in levelList"
        :key="item.path"
        :to="item.path"
      >{{ item.name== 'hfyj' ||  item.name== 'aboutUsDetail'? getPageName(item.meta.title): item.meta.title 
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="right-menu">
      <div class="right-menu-item top-search">
      </div>
      <el-dropdown
        class="avatar-container right-menu-item"
        trigger="hover"
      >
        <div class="avatar-wrapper">
          <div class="avatar_wrap">
            <span class="user-name">{{roleName}}</span>
            <i class="el-icon-arrow-down" />
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in getRoleList"
            :key="item.id"
            @click.native="changeRole(item.roleName)"
          >
            <span style="display:block;">{{item.displayName}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        class="avatar-container right-menu-item"
        trigger="hover"
      >
        <div class="avatar-wrapper">
          <img
            src="@/assets/images/avatar.jpg"
            alt=""
            class="user-avatar"
          >
          <div class="avatar_wrap">
            <span class="user-name">{{getUser.name}}</span>
            <i class="el-icon-arrow-down" />
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <!-- <span style="display:block;" @click="isPageVisible"></span> -->
            <router-link to="/personage">个人管理</router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <span
              style="display:block;"
              @click="getOut"
            >退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
import { getRole } from '@/api/user'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'Navbar',
  data() {
    return {
      searchValue: '',
      levelList: [],
      round: '',
      isPageVisible: false,
      roundList: [
        {
          value: 0,
          label: '2023年度-本科-春季',
        },
        {
          value: 1,
          label: '2022年度-本科-春季',
        },
      ],
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    },
  },
  computed: {
    ...mapGetters(['getUser', 'getRoleList', 'getRole']),
    roleName() {
      const roleData = this.getRoleList.filter(
        (item) => item.roleName === this.getRole
      )[0]
      if (roleData) {
        return roleData.displayName
      }
      return ''
    },
  },
  mounted() {
    // console.log(this.$store.state.pageList.filter(item=>item.id == $route.params.id)[0].pageName);
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    ...mapMutations(['deleteUser', 'clearToken', 'setRole']),
    getBreadcrumb() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )
      this.levelList = matched
    },
    // 退出登录
    getOut() {
      this.deleteUser()
      this.clearToken()
      this.$router.push('/login')
    },
    changeRole(name) {
      this.setRole(name)
      this.$router.push('/')
      setTimeout(() => {
        window.location.reload()
      }, 100)
    },
    getPageName(name) {
      //   const itemData = this.$store.state.pageList.filter(
      //     (item) => item.id == this.$route.params.id
      //   )[0]
      //   if (itemData) {
      //     return itemData.pageName
      //   }
      return name
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/navbar.scss';
</style>
